import { DatePicker, DatePickerHandles } from 'common/DatePicker/DatePicker'
import { PropertyValue, Property } from 'api/clients/PropertyClient'
import Styles from '../PropertyValue.module.scss'
import { useLayoutEffect, useRef } from 'react'
import { useKey } from 'react-use'
import {
  SelectPropertyEventDetails,
  selectPropertyEventName,
} from 'screens/Finder/components/FileTree/events/selectProperty'

interface Props {
  property: Property
  propertyValue?: PropertyValue
  onCreate?: (propertyValue: PropertyValue) => void
  onUpdate?: (propertyValue: PropertyValue) => void
  onCancel?: () => void
}

export const DateEdit = ({ property, propertyValue, onCreate, onUpdate, onCancel }: Props) => {
  const datePickerRef = useRef<DatePickerHandles>(null)

  const handleDateChange = (date?: string) => {
    const value = date ?? ''
    if (propertyValue) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      onUpdate!({
        ...propertyValue,
        value,
      })
    } else {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      onCreate!({
        value,
        property_id: property.id,
      } as PropertyValue)
    }
  }

  useKey(
    'Escape',
    () => {
      onCancel?.()
    },
    { options: true },
  )

  useKey(
    'Enter',
    () => {
      setTimeout(() => {
        document.body.dispatchEvent(
          new CustomEvent<SelectPropertyEventDetails>(selectPropertyEventName, {
            bubbles: false,
            detail: 'Down',
          }),
        )
      }, 0)
    },
    { options: true },
  )

  useLayoutEffect(() => {
    datePickerRef.current?.setEditing(true)
  }, [])

  return (
    <DatePicker
      ref={datePickerRef}
      variant="table-date-picker"
      size="md"
      value={propertyValue?.value ?? ''}
      onChange={handleDateChange}
      wrapperClassName={Styles.datePicker}
      dateFormat={property.meta?.date_format}
    />
  )
}
